import React, { useState, useEffect } from 'react';
import { Progress } from 'antd';
import "./index.less";

export default function ProgressT({ type='circle', title='', showPrecent=false, strokeColor='', opts={}, callback }){

  const [show, setShow] = useState(true);
   
    const [count, setCount] = useState(0);

    useEffect(() => {
      const timer = setInterval(() => {
        if (count <= 99 && count != 0) {
          setCount(count + 1);
        }
      }, 25);
      if (count == 100) {
        setShow(false);
        callback && callback();
      }
      return () => clearInterval(timer);
    }, [count]);

    useEffect(() => {
      setCount(1);
    }, [])

    return (<div>
      {show ? (
          count < 99 ? (
            <div className={type === 'line' ? '' : 'TUI-Progress'}>
              <Progress
                type={type}
                percent={count}
                format={count => showPrecent ? count+'%' : title||'加载中'}
                {...strokeColor ? { strokeColor }: {}}
                {...opts}
              />
            </div>
          ) : (
            <div className={type === 'line' ? '' : 'TUI-Progress'}>
              <Progress
                type={type}
                percent={100} 
                {...strokeColor ? { strokeColor }: {}}
                {...opts}/>
            </div>
          )
        ) : (
          ''
        )}
  </div>)
}
